import { useEffect, useState } from "react"

const DEFAULT_WIDTH = "100vw"
const DEFAULT_HEIGHT = "100vh"

export default function useWindowDimensions() {
  const hasWindow = typeof window !== "undefined"

  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : DEFAULT_WIDTH
    const height = hasWindow ? window.innerHeight : DEFAULT_HEIGHT
    return {
      width,
      height,
    }
  }

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions())
      }

      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWindow])

  return windowDimensions
}
